<template>
  <b-card no-body class="shadowed h-100">
    <div class="row mx-0">
      <div class="col-12 col-md-4 p-4 d-flex order-0">
        <b-img :src="illustration" class="w-100 h-100"></b-img>
      </div>
      <div class="col-12 col-md-8 pt-md-4 pb-4 px-4">
        <small class="font-weight-bold text-primary">
          {{ preTitle }}
        </small>
        <h5 class="text-primary">{{ name }}</h5>
        <p>{{ description }}</p>
        <div>
          <div class="row mx-0 align-items-end h-100">
            <div class="col-12 px-0" v-if="progress">
              <b-skeleton v-if="progress.loading" class="mb-3" height="10px"></b-skeleton>
              <b-progress
                v-else
                :value="progress.percentage"
                :max="100"
                height="10px"
                class="card-progress border-side-rounded"
                variant="secondary"
              />
            </div>
            <div class="col-12 px-0 text-left" v-if="progress && !progress.loading">
              <p class="mb-0">
                <small v-if="progress.completedUnits">
                  <span class="text-secondary font-weight-bold">
                    {{ progress.completedUnits }} / {{ progress.totalUnits }}
                  </span>
                  <span class="text-muted">
                    {{ trans("global.progressbar.stream") }}
                  </span>
                </small>
                <small v-else>
                  <span class="text-secondary font-weight-bold"> {{ progress.percentage }}% </span>
                  <span class="text-muted">
                    {{ trans("global.progressbar.program") }}
                  </span>
                </small>
              </p>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <b-button
            variant="secondary"
            @click="$emit('ctaClicked')"
            class="font-weight-bold"
            :disabled="buttonDisabled"
          >
            {{ buttonText }}
          </b-button>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import NewFlag from "../../atoms/NewFlag";

export default {
  name: "HighlightedServiceCard",
  components: { NewFlag },
  props: {
    name: String,
    description: String,
    illustration: String,
    buttonText: String,
    progress: Object,
    preTitle: String,
    buttonDisabled: Boolean,
  },
};
</script>

<style scoped lang="scss">
.border-side-rounded {
  border-radius: 5px !important;
}
</style>
